import React, { Component } from 'react';
import { Container } from 'reactstrap';

import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from './services/FirebaseService';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import CreateAccountPage from './pages/CreateAccountPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

class App extends Component {
  constructor(props) {
    super(props);

    this.unsubscribeToOnAuthStateChanged =
      onAuthStateChanged(this.onAuthStateChanged);

    this.state = {
      user: null,
      activePage: ''
    };
  }

  componentWillUnmount() {
    this.unsubscribeToOnAuthStateChanged();
  }

  onAuthStateChanged = (user) => {
    this.setState({
      user,
      activePage: user ? 'HOME' : 'LOGIN'
    });
  }

  onShowLoginPage = (message) => {
    this.setState({
      activePage: 'LOGIN',
      messageType: message && message.type,
      message: message && message.message
    });
  };

  onShowCreateAccountPage = (message) => {
    this.setState({
      activePage: 'CREATE_ACCOUNT',
      messageType: message && message.type,
      message: message && message.message
    });
  };

  onShowResetPasswordPage = (message) => {
    this.setState({
      activePage: 'RESET_PASSWORD',
      messageType: message && message.type,
      message: message && message.message
    });
  };

  render() {

    let page;

    const homePage = (
      <HomePage
        onLogout={signOut}
        user={this.state.user}
      />
    );

    const loginPage = (
      <LoginPage
        onLoginAttempt={signInWithEmailAndPassword}
        onShowCreateAccountPage={this.onShowCreateAccountPage}
        onShowResetPasswordPage={this.onShowResetPasswordPage}
        message={this.state.message}
        messageType={this.state.messageType}
      />
    );

    const createAccountPage = (
      <CreateAccountPage
        onCreateAccountAttempt={createUserWithEmailAndPassword}
        onShowLoginPage={this.onShowLoginPage}
        message={this.state.message}
        messageType={this.state.messageType}
      />
    );

    const resetPasswordPage = (
      <ResetPasswordPage
        onSendPasswordResetEmail={sendPasswordResetEmail}
        onShowLoginPage={this.onShowLoginPage}
        message={this.state.message}
        messageType={this.state.messageType}
      />
    );

    switch(this.state.activePage) {
      case 'HOME':
        page = homePage;
        break;
      case 'LOGIN':
        page = loginPage;
        break;
      case 'CREATE_ACCOUNT':
        page = createAccountPage;
        break;
      case 'RESET_PASSWORD':
        page = resetPasswordPage;
        break;
      default:
        page = <div/>;
    }

    return (
      <Container>
        {page}
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx